export const OVERLAY_BLUR = 10